import { AppConfigProvider } from "@/app/providers/AppConfigContext";
import { SettingsProvider, useSettings } from "@/app/providers/SettingsContext";
import AppShell from "@/app/ui/AppShell";
import { TimezoneProvider } from "@/shared/contexts/TimezoneContext";
import { GlobalErrorBoundary } from "@/shared/ui/ErrorBoundary";
import { TooltipProvider } from "@/shared/ui/shadcn/tooltip";

/**
 * Feeds the practice timezone from settings into the display-timezone context,
 * so every wall-clock value in the app is rendered in the practice's timezone
 * rather than the device's.
 */
function PracticeTimezoneBridge({ children }: { children: React.ReactNode }) {
  const { formats } = useSettings();
  return <TimezoneProvider timezone={formats.timezone}>{children}</TimezoneProvider>;
}

function App() {
  return (
    <GlobalErrorBoundary>
      <TooltipProvider>
        <SettingsProvider>
          <PracticeTimezoneBridge>
            <AppConfigProvider>
              <AppShell />
            </AppConfigProvider>
          </PracticeTimezoneBridge>
        </SettingsProvider>
      </TooltipProvider>
    </GlobalErrorBoundary>
  );
}

export default App;
